import classNames from 'classnames'
import * as React from 'react'

import { RedGreenText } from '../../components/RedGreenText'
import { TableAlign } from '../../components/Table'
import { shortFormatNumber } from '../../util'
import { DividendDataEnum, DividendsColumnsType } from './types'

const getColumns = (yearKeys: string[], isCompact: boolean) => {
  const commonClassName = classNames('px-4 last:pr-11', {
    'w-22 last:w-29.5': !isCompact,
    'w-17 last:w-24.5': isCompact,
  })

  const columns: DividendsColumnsType['columns'] = yearKeys.map((year) => ({
    id: year,
    name: year,
    align: TableAlign.Right,
    className: commonClassName,
    renderColumn: (data) => {
      const annualDividend = data.values.find((annualDividend) => annualDividend.year === year)
      const annualDividendValue = annualDividend?.value ?? null
      if (typeof annualDividendValue !== 'number') return <span className="text-muted-2">—</span>
      const value = shortFormatNumber(annualDividendValue, { fractions: 2 })
      return <span className={classNames({ 'text-muted-2': annualDividend?.isEstimate })}>{value}</span>
    },
  }))

  const subColumns: DividendsColumnsType['subColumns'] = {
    [DividendDataEnum.yoyChange]: yearKeys.map((year) => ({
      id: year,
      name: year,
      align: TableAlign.Right,
      className: commonClassName,
      renderColumn: (data) => {
        const annualDividend = data.values.find((annualDividend) => annualDividend.year === year)
        const annualDividendValue = annualDividend?.value ?? null
        return (
          <RedGreenText value={annualDividend?.isEstimate ? null : annualDividendValue} rightContent={null}>
            {shortFormatNumber(annualDividendValue, { defaultValue: '—' })}
          </RedGreenText>
        )
      },
    })),
    [DividendDataEnum.yoyChangePct]: yearKeys.map((year) => ({
      id: year,
      name: year,
      align: TableAlign.Right,
      className: commonClassName,
      renderColumn: (data) => {
        const annualDividend = data.values.find((annualDividend) => annualDividend.year === year)
        const annualDividendValue = annualDividend?.value ?? null
        return (
          <RedGreenText
            value={annualDividend?.isEstimate ? null : annualDividendValue}
            rightContent={annualDividendValue ? '%' : null}
          >
            {annualDividendValue?.toFixed(2) ?? '—'}
          </RedGreenText>
        )
      },
    })),
  }
  return { columns, subColumns }
}

export function useTableColumns(yearKeys: string[], isCompact: boolean) {
  return React.useMemo(() => getColumns(yearKeys, isCompact), [yearKeys, isCompact])
}
